<template>
  <div class="part mt-4">
    <div class="header_style">
      <h2 class="h2_style mb-0">概览</h2>
      <div>
        <!-- <el-popconfirm
          v-if="project_id == 57"
          @confirm="handleConfirm"
          title="确认删除截图?"
        >
          <template #reference>
            <span
              style="
                font-size: 14px;
                color: #4371fd;
                margin-right: 10px;
                cursor: pointer;
              "
              >删除截图</span
            >
          </template>
        </el-popconfirm> -->
        <a
          v-if="logUrl != ''"
          :href="logUrl"
          download
          style="cursor: pointer; margin-right: 10px"
        >
          <i class="el-icon-download"></i>下载日志</a
        >
        <a href="javascript:void(0)" class="me-4" @click.prevent="downloadData"><i class="el-icon-download"></i>下载当前数据</a>
        <a :href="downloadUrl" download><i class="el-icon-download"></i>下载Excel文件</a>
      </div>
    </div>

    <div class="part__cnt">
      <div class="label_style mt-3">
        <template v-for="item in overviewValue2">
          <ul v-if="item.value !== '-'" :key="item.label">
            <li v-if="item.value !== '-'">
              <span>{{ item.label }}</span>
              <el-tooltip
                v-if="item.tooltip"
                class=""
                effect="dark"
                :content="item.tooltip"
                placement="bottom">
                <i class="el-icon-question" style="color: #acb0bf;font-size: 16px;"></i>
              </el-tooltip>
            </li>
            <li v-if="item.value !== '-'">{{ item.value ?? '-' }}</li>
          </ul>
        </template>
      </div>

      <div class="overview_table">
        <el-popover
          placement="bottom-start"
          width="200"
          trigger="hover"
          content="All：指全部区域；所有标记区域：将标记过的区域作为整体来查看">
          <template #reference>
            <span class="table_p">标签<i class="el-icon-question ms-1"></i></span>
          </template>
        </el-popover>

        <el-table
          ref="dataTable"
          :data="testInfoList"
          size="mini"
          header-cell-class-name="tabelHeader"
          class="tabelStyle mt-2"
          @select="handleSelect"
        >
          <el-table-column
            label-class-name="DisabledSelection"
            type="selection"
          >
          </el-table-column>
          <el-table-column
            v-for="item in getCol()"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            align="center"
            :fixed="item.fixed"
            width="100"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {exportFile} from '@/views/common/index.js'

const useFields = {
  computed: {
    overviewValue2() {
      let data2 = this.testInfo3,
        data = this.testInfo3,
        proj_name = this.testInfo0?.proj_name,
        result = []

      // label_avg_data接口：全选/单标签时返回大写键(来自custom_data)；
      // 多标签聚合时后端只返回小写键(如avg_fps)，缺失字段再用勾选标签行数据按时长加权补算
      const pick = (...keys) => {
        for (const key of keys) {
          const val = data2?.[key]
          if (val !== undefined && val !== null && val !== '') return val
        }
        return undefined
      }
      const aggPick = (...keys) => pick(...keys) ?? this.aggregateLabelRows(...keys)

      if (
        proj_name === "AOV" ||
        proj_name === "AOV测试项目" ||
        proj_name === "AOV主干Garena" ||
        proj_name === "AOV主干Tencent"
      ) {
        result = [
          {
            label: "Avg(FPS)",
            value: pick('Avg(FPS)', 'avg_fps'),
          },
          {
            label: "CPU<60%[%]",
            value: data2?.cpu_lt_60_pcnt,
          },
          {
            label: "Avg(AppCPU)[%]",
            value: pick('Avg(AppCPU)[%]', 'avg_cpu'),
          },
          {
            label: "Max(MonoMem)[M]",
            value: data2?.max_mono_total,
          },
          {
            label: "Used(MonoMem)[M]",
            value: data2?.max_mono_used,
          },
          {
            label: "Max(PSS)[M]",
            value: data2?.max_pss,
          },
          {
            label: "Max(Triangle)[个]",
            value: data2?.max_triangle,
          },
          {
            label: "Max(DrwaCall)[次]",
            value: data2?.max_dc,
          },
          {
            label: "卡顿率[%]",
            value: data2?.lag_pcnt,
          },
          {
            label: "Mono堆内存峰值(MB)",
            value: data2?.monomem,
          },
          {
            label: "GC次数",
            value: data2?.gc,
          },

          {
            label: "DrawCall均值",
            value: data2?.avg_dc,
          },
          {
            label: "三角形数均值",
            value: data2?.Tris,
          },
          {
            label: "顶点数均值",
            value: data2?.Verts,
          },
        ]
      } else {
        result = [
          {
            label: "Avg(FPS)",
            value: pick('Avg(FPS)', 'avg_fps'),
          },
          {
            label: "Smooth(稳帧指数)",
            value: aggPick('Smooth'),
            tooltip: '稳帧指数，游戏或者应用画面平稳指标，一般游戏、视频建议&lt;8，应用类APP(滑动时)建议&lt;20',
          },
          {
            label: "TinyJank(极微小卡顿)(/10min)",
            value: aggPick('TinyJank(/10min)'),
            tooltip: '平均10分钟微小卡顿次数',
          },
          {
            label: "SmallJank(微小卡顿)(/10min)",
            value: aggPick('SmallJank(/10min)'),
            tooltip: '平均10分钟微小卡顿次数',
          },
          {
            label: "Jank",
            value: data?.jank,
          },
          {
            label: "BigJank",
            value: data?.big_jank,
          },
          {
            label: "Stutter(卡顿率) [%]",
            value: pick('Stutter[%]', 'lag_pcnt'),
          },
          {
            label: "Avg(AppCPU)[%]",
            value: pick('Avg(AppCPU)[%]', 'avg_cpu'),
          },
          {
            label: "Avg(AppCPU) [%]Normalized",
            value: pick('Avg(AppCPU)[%]Normalized', 'app_cpu_normalized'),
          },
          {
            label: "Avg(CTemp)[°C])",
            value:
              this.testInfo0?.device?.toUpperCase()?.indexOf("IPHONE") != -1
                ? "-" : pick('Avg(CTemp)[℃]', 'cpu_temp'),
          },
          {
            label: "Peak(Memory) [MB]",
            value: pick('Peak(Memory)[MB]', 'max_pss'),
          },
          {
            label: "Avg(BTemp)[°C])",
            value: pick('Avg(BTemp)[℃]', 'battery_temp'),
          },
          {
            label: "CPU<=60%[%]",
            value: data?.cpu_lt_60_pcnt,
          },
          {
            label: "Send[KB/s]",
            value: data?.send,
          },
          {
            label: "Recv[KB/s]",
            value: data?.recv,
          },
          {
            label: "Send[KB/10min]",
            value: aggPick('Send[KB/10min]'),
          },
          {
            label: "Recv[KB/10min]",
            value: aggPick('Recv[KB/10min]'),
          },
          {
            label: "Avg(Power) [mW]",
            value: aggPick('Avg(Power)[mW]'),
            tooltip: '平均功耗(仅在WiFi模式下支持)',
          },
          {
            label: "FPower(帧能耗) [mW]",
            value: aggPick('FPower[mW]'),
          },
        ];

        if (
          proj_name === "CF手游" ||
          proj_name === "CFM手游测试"
        ) {
          result.push(
            {
              label: "Max(MonoMem)[M]",
              value: data2?.max_mono_total,
            },
            {
              label: "Used(MonoMem)[M]",
              value: data2?.max_mono_used,
            },
            {
              label: "Max(PSS)[M]",
              value: data2?.max_pss,
            },
            {
              label: "Max(Triangle)[个]",
              value: data2?.max_triangle,
            },
            {
              label: "Max(DrwaCall)[次]",
              value: data2?.max_dc,
            },
            {
              label: "卡顿率[%]",
              value: data2?.lag_pcnt,
            },
            {
              label: "Mono堆内存峰值(MB)",
              value: data2?.monomem,
            },
            {
              label: "GC次数",
              value: data2?.gc,
            },
            {
              label: "DrawCall均值",
              value: data2?.avg_dc,
            },
            {
              label: "三角形数均值",
              value: data2?.Tris,
            },
            {
              label: "顶点数均值",
              value: data2?.Verts,
            }
          );
        }

        if (proj_name === "QQ飞车手游") {
          result.push(
            {
              label: "CPU0功耗",
              value: data?.cpu_power_0,
            },
            {
              label: "CPU1功耗",
              value: data?.cpu_power_1,
            },
            {
              label: "CPU2功耗",
              value: data?.cpu_power_2,
            },
            {
              label: "CPU3功耗",
              value: data?.cpu_power_3,
            },
            {
              label: "CPU4功耗",
              value: data?.cpu_power_4,
            },
            {
              label: "CPU5功耗",
              value: data?.cpu_power_5,
            },
            {
              label: "CPU6功耗",
              value: data?.cpu_power_6,
            },
            {
              label: "CPU7功耗",
              value: data?.cpu_power_7,
            }
          );
        }
      }

      return result
    }
  }
}

export default {
  mixins: [useFields],

  inject: ['onSelectLabel'],

  props: {
    data: Object,
    testInfo3: Object,
    labelInfo: Array,
    testInfoList: Array,
    testInfo0: Object,
    testInfo2: Object,
  },

  data() {
    return {
      logUrl: '',
      //downloadUrl: '',
      dataTable: null,
      selectedRow: [],
    }
  },

  computed: {
    project_id() {
      return Number(this.$route.query.project)
    },

    id_test() {
      return this.$route.query.id_test
    },

    isAllChecked() {
      return this.selectedRow.length == this.testInfoList.length
    },

    downloadUrl() {
      const {date, project, id_test} = this.testInfo2
      return `/static/perfdog/${date}/${project}/${id_test}.xlsx`
    },
  },

  watch: {
    isAllChecked: {
      handler(val) {
        this.$emit('checked-change', val)
      },
      immediate: true,
    }
  },

  methods: {
    init() {
      this.$refs.dataTable.toggleAllSelection()
      this.selectedRow = this.testInfoList
    },

    // 多标签聚合时，后端label_avg_data不返回部分指标(如Smooth)，
    // 用勾选标签的行数据(label_info含每标签完整统计)按时长加权平均补算
    aggregateLabelRows(...keys) {
      const rows = (this.selectedRow || []).filter(
        row => row && row.id_label != 'all' && row.id_label != 'all_label'
      )
      let totalWeight = 0
      let totalValue = 0

      for (const row of rows) {
        const weight = Number(row.duration)
        if (!weight) continue

        let value
        for (const key of keys) {
          const num = Number(row[key])
          if (row[key] !== undefined && row[key] !== null && row[key] !== '-' && isFinite(num)) {
            value = num
            break
          }
        }
        if (value === undefined) continue

        totalWeight += weight
        totalValue += value * weight
      }

      if (!totalWeight) return undefined
      return Number((totalValue / totalWeight).toFixed(2))
    },

    handleConfirm() {
      //
    },

    async downloadData() {
      const res = await axios(`performance/download_csv/?project=${this.project_id}&id_test=${this.id_test}`, {responseType: 'blob'})
      exportFile(res)
    },

    toggleSelect(selection, row) { //切换选中状态
      this.selectedRow = selection
      const rowAll = this.testInfoList[0]

      if (row.id_label == 'all') {
        if (selection.includes(row)) {
          this.$refs.dataTable.toggleAllSelection()
          this.selectedRow = this.testInfoList
        } else {
          this.$refs.dataTable.clearSelection()
          this.selectedRow = []
        }
      } else {
        if (selection.includes(row)) {
          if (selection.length >= (this.testInfoList.length - 1)) {
            this.$refs.dataTable.toggleRowSelection(rowAll, true)
            this.selectedRow = this.testInfoList
          }
        } else {
          this.$refs.dataTable.toggleRowSelection(rowAll, false)
          this.selectedRow = selection.filter(item => item.id_label != 'all')
        }
      }
    },

    handleSelect(selection, row) {
      this.toggleSelect(selection, row)
      this.onSelectLabel()
    },

    getCol() {
      const project_id = this.project_id
      if (
        project_id === 34 ||
        project_id === 40 ||
        project_id === 47 ||
        project_id === 27
      ) {
        return [
          // {type: 'selection', align: 'center', fixed: true},
          { prop: "tagName", label: "标签", align: "center", fixed: true },
          { prop: "avg_fps", label: "Avg(FPS)" },
          { prop: "var_fps", label: "Var(FPS)" },
          { prop: "min_fps", label: "Min(FPS)" },
          { prop: "lag_pcnt", label: "卡顿率[%]" },
          { prop: "big_jank", label: "BigJank" },
          { prop: "jank", label: "Jank" },
          { prop: "fps_lt_10_pcnt", label: "FPS<10[%]" },
          { prop: "fps_lt_18_pcnt", label: "FPS>18[%]" },
          { prop: "fps_lt_25_pcnt", label: "FPS>25[%]" },
          { prop: "fps_lt_40_pcnt", label: "FPS>40[%]" },
          { prop: "avg_cpu", label: "Avg(CPU)[%]" },
          { prop: "cpu_lt_60_pcnt", label: "CPU<60[%]" },
          { prop: "cpu_lt_80_pcnt", label: "CPU<80[%]" },
          { prop: "max_pss", label: "Max(PSS)[M]" },
          { prop: "avg_pss", label: "Avg(PSS)[M]" },
          { prop: "max_mono_used", label: "Max(MonoUsed)[M]" },
          { prop: "max_mono_total", label: "Max(MonoTotal)[M]" },
          // {prop: 'dps', label: 'DPS[KB/s]'},
          { prop: "avg_dc", label: "Avg(Drawcall)[次]" },
          { prop: "max_dc", label: "Max(Drawcall)[次]" },
          { prop: "max_triangle", label: "Max(Triangle)[次]" },
          { prop: "duration", label: "时长[ms]" },
          // {prop: 'avg_flow', label: 'Avg(Flow)[KB/s]'},
          { prop: "max_swap", label: "Max(Swap)[M]" },
          { prop: "max_vss", label: "Max(Vss)[M]" },
          { prop: "max_swap_add_pss", label: "Max(SwapAddPss)[M]" },

          { prop: "lag_cnt", label: "总卡顿[次]" },
          { prop: "single_peak_lag_cnt", label: "毛刺卡顿[次]" },
          { prop: "multiple_peak_lag_cnt", label: "连续卡顿[次]" },
          { prop: "continue_low_lag_cnt", label: "持续卡顿[次]" },
          // {prop: 'lag_pcnt', label: '卡顿率[%]'},
          { prop: "lag_freq", label: "卡顿频率[次/min]" },
        ];
      } else {
        return [
          // {type: 'selection', align: 'center', fixed: true},
          { prop: "tagName", label: "标签", align: "center", fixed: true },
          { prop: "avg_fps", label: "Avg(FPS)" },
          { prop: "var_fps", label: "Var(FPS)" },
          { prop: "min_fps", label: "Min(FPS)" },
          { prop: "lag_pcnt", label: "卡顿率[%]" },

          { prop: "fps_lt_10_pcnt", label: "FPS<10%[%]" },
          { prop: "fps_lt_18_pcnt", label: "FPS>18%[%]" },
          { prop: "fps_lt_25_pcnt", label: "FPS>25%[%]" },
          { prop: "fps_lt_40_pcnt", label: "FPS>40%[%]" },
          { prop: "avg_cpu", label: "Avg(CPU)[%]" },
          { prop: "cpu_lt_60_pcnt", label: "CPU<60%[%]" },
          { prop: "cpu_lt_80_pcnt", label: "CPU<80%[%]" },
          { prop: "max_pss", label: "Max(PSS)[M]" },
          { prop: "avg_pss", label: "Avg(PSS)[M]" },
          { prop: "max_mono_used", label: "Max(MonoUsed)[M]" },
          { prop: "max_mono_total", label: "Max(MonoTotal)[M]" },
          // {prop: 'dps', label: 'DPS[KB/s]'},
          { prop: "avg_dc", label: "Avg(Drawcall)[次]" },
          { prop: "max_dc", label: "Max(Drawcall)[次]" },
          { prop: "max_triangle", label: "Max(Triangle)[次]" },
          { prop: "duration", label: "时长[ms]" },
          // {prop: 'avg_flow', label: 'Avg(Flow)[KB/s]'},
          { prop: "max_swap", label: "Max(Swap)[M]" },
          { prop: "max_vss", label: "Max(Vss)[M]" },
          { prop: "max_swap_add_pss", label: "Max(SwapAddPss)[M]" },

          { prop: "lag_cnt", label: "总卡顿[次]" },
          { prop: "single_peak_lag_cnt", label: "毛刺卡顿[次]" },
          { prop: "multiple_peak_lag_cnt", label: "连续卡顿[次]" },
          { prop: "continue_low_lag_cnt", label: "持续卡顿[次]" },
          // {prop: 'lag_pcnt', label: '卡顿率[%]'},
          { prop: "lag_freq", label: "卡顿频率[次/min]" },
        ]
      }
    }
  }
}
</script>

<style scoped>
@import "./common.css";

.table_p {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px !important;
}
.table_p i {
  color: #acb0bf;
}

.tabelStyle :deep(.tabelHeader .el-checkbox) {
  display: none;
}
</style>